export default __webpack_public_path__ + "static/media/hog@3x.3ab46cb9.jpg";